import { Box, Container, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        color: "#000",
        padding: "10px 0",
        marginTop: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            borderTop: "1px solid #c0c0c0",
            paddingTop: "25px",
            marginTop: "0px",
            textAlign: "center",
            color: "#c0c0c0",
          }}
        >
          <Typography variant="body2" sx={{ color: "#cccccc" }}>
            <a
              href="https://michaljaskulski.pl"
              style={{ textDecoration: "none", color: "inherit" }}
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              &copy; {new Date().getFullYear()} Allworks sp. z o.o.
            </a>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
